<template>
	<div class="filter-bar">
		<!-- Filter dropdown for mobile-->
		<div class="filters-mobile">
			<dropdown title="Expedition Filters" class="filters hidden-md hidden-lg" container-class="row">
				<dropdown v-for="(title, id) in filterGroupNames" :title="title" :key="id" class="filter col-xs-6" v-if="filters[id]">
					<filter-checkbox-group :checkboxes="filters[id]" :filter="id"></filter-checkbox-group>
				</dropdown>
			</dropdown>
		</div>

		<!-- Desktop only -->
		<div class="filters-desktop">
			<h1 class="hidden-xs hidden-sm">Cruise Search</h1>
			<dropdown v-for="(title, id) in filterGroupNames" v-if="filters[id]" :title="title" :key="id" class="filter hidden-xs hidden-sm col-md-3">
				<filter-checkbox-group :checkboxes="filters[id]" :filter="id"></filter-checkbox-group>
			</dropdown>
		</div>
	</div>
</template>

<script>
	import FilterCheckboxGroup from './FilterCheckboxGroup';
	import Dropdown from './Dropdown';

	export default {
	data: function () {
		return {
			// Order of filters and titles.
			filterGroupNames: {
				regionIds: 'Region',
				departureDates: 'Sailing date',
				routeIds: 'Route',
				operatorIds: 'Operator',
				shipIds: 'Ship',
			},
		};
	},
	computed: {
		filters: function () {
			// Make a copy of the values from the store so they can be modified.
			var availableFilterValues = Object.assign({}, this.$store.getters.availableFilterValues);

			// Remove fields for which filters are not wanted.
			delete availableFilterValues.routeIds;

			// Regions are sorted in a fixed order.
			var regionOrder = [
				'Antarctica',
				'Antarctic Circle',
				'South Georgia',
				'Falklands',
				'Ross Sea',
				'Antarctic Fly Cruises',
				'Svalbard',
				'Greenland',
				'Iceland',
				'Canadian Arctic',
				'Northwest Passage',
				'Russian Arctic',
				'North Pole',
				'Russian Far East',
				'World Cruise',
				'Patagonia',
			];

			var orderedFilters = {};

			for (var filter in availableFilterValues)
			{
				var unorderedFilters = [];
				for (var id in availableFilterValues[filter])
					unorderedFilters.push({id: id, label: availableFilterValues[filter][id]});

				if (filter == 'regionIds')
				{
					var sortFunc = function (a, b)
					{
						// Find the location of the values in the manually sorted list.
						var aIndex = regionOrder.indexOf(a.label);
						var bIndex = regionOrder.indexOf(b.label);

						// If a is in regionOrder and b is not, sort a first.
						if (aIndex != -1 && bIndex == -1)
							return -1;

						// If b is in regionOrder and a is not, sort b first.
						if (aIndex == -1 && bIndex != -1)
							return 1;

						// If both are in regionOrder, sort by index.
						if (aIndex != -1 && bIndex != -1)
							return aIndex < bIndex ? -1 : 1;

						// If neither are in regionOrder, sort alphabetically.
						if (a.label == b.label)
							return 0;

						return a.label < b.label ? -1 : 1;
					};

					unorderedFilters.sort(sortFunc);

				}
				else if (filter != 'departureDates')
				{
					unorderedFilters.sort((a, b) => a.label == b.label ? 0 : (a.label < b.label ? -1 : 1));
				}

				orderedFilters[filter] = unorderedFilters;
			}

			return orderedFilters;
		},
	},

	components: {
		FilterCheckboxGroup,
		Dropdown,
	}
}
</script>

<style lang="scss" scoped>
.filter-checkbox-group {
	margin-bottom: 10px;
}

.filters {
	border: unset;
	background: #28354b;
	color: white;
}

.filters-desktop {
	margin: 0 -10px;

	h1 {
		margin-left: 10px;
	}
}

.filter {
	@media (max-width: 768px) {
		margin-top: 10px;
		padding: 0 5px !important;
	}

	@media (min-width: 769px) {
		padding: 20px 10px !important;
	}
}
</style>
